import { render, staticRenderFns } from "./bot-channel-form-whatsapp.vue?vue&type=template&id=42c77d74&"
import script from "./bot-channel-form-whatsapp.vue?vue&type=script&lang=js&"
export * from "./bot-channel-form-whatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports